module.exports = __webpack_public_path__ + "static/img/5.311edc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting811/images/5.png
// module id = ZJWd
// module chunks = 4